<template>
    <div class="ConnaitreConfiance">
        <HeadPage :title="'Ils nous font confiance'" 
                  :category="'Nous connaitre'"
                  :img="null"
                  :imgAlt="null"
        />
        <br>
        <br>
        <br>
        <Partners :items="CLIENTS"
                :limit="4"
                :auto="true"
                type="clients"
            />
    </div>
</template>

<script>
import HeadPage from '../global/HeadPage.vue'
import Partners from '../global/Partners.vue'
import {CLIENTS} from "../../constant/CLIENTS";

export default {
    name: "ConnaitreConfiance",
    components: {
        HeadPage,
        Partners
    },
    data() {
      return {
        CLIENTS
      }
    }
}
</script>

<style scoped>
/* 
* Global 
*/
.ConnaitreConfiance {
    padding-bottom: 75px;
}
</style>